import { widgetService } from '@/services/api'

const initialStates = {
    status: 'LOADING',
    widgets: [],
    durationValue: 7,
    params: {
    },
}

const mutations = {
    loading(state) {
        state.status = 'LOADING'
    },
    setWidgetsData(state, data) {
        state.status = 'SET_LIST'
        state.widgets = data
    },
    setDurationValue(state, val) {
        state.status = 'SET_DURATION_VALUE'
        state.durationValue = val
    },
    setParams(state, params) {
        state.status = 'SET_PARAMS'
        state.params = Object.assign({}, state.params, params)
    },
    resetParams(state) {
        state.status = 'RESET_PARAMS'
        state.params = {
        }
    },
    error(state) {
        state.status = 'ERROR'
    },
}

const getters = {
    status: state => state.status,
    widgets: state => state.widgets,
    durationValue: state => state.durationValue,
}

const actions = {
    setParamsAndFetch({dispatch}, params) {
        dispatch('setParams', params)
        dispatch('fetch')
    },
    setParams({commit}, params) {
        commit('setParams', params)
    },
    resetParams({commit}) {
        commit('resetParams')
    },
    fetch({commit}, params){
        commit('loading')

        return new Promise((resolve, reject) => {
            widgetService.fetch(params)
                .then(response => {
                    const result = response.data
                    commit('setWidgetsData', result.data)
                    resolve(result)
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? error.response.data : error.response)
                })
        })
    },
    setDurationValue({commit}, val) {
        commit('setDurationValue', val)
    }
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}